(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/xpert.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/xpert.js');

'use strict';

svs.maltipset = svs.maltipset || {};
svs.maltipset.models = svs.maltipset.models || {};

svs.maltipset.models.Xpert = Backbone.Model.extend({
  url: function() {
    var url;

    if (this.getSystemType() === 'SROW') {
      url = '/wager/1/maltipset/pix/singlerows?flavour=SafeMaltipset&drawNumber=' +
      this.get('drawNumber') +
      '&numRows=' +
      this.getNumRows();
    } else {
      url = '/wager/1/maltipset/pix?flavour=SafeMaltipset&systemNumberMapping=' +
      this.get('xpertSize') +
      '&drawNumber=' +
        this.get('drawNumber');
    }

    return svs.core.jupiter.url() + url;
  },
  fetch: function(options) {
    var self = this;
    var origSuccess;
    var origError;

    options = _.defaults({}, options, {
      success: function() { },
      error: function() { }
    });

    options.type = 'POST';
    var baseRowsArray = this.get('baseRow');
    if (baseRowsArray && baseRowsArray.length > 0) {
      var baseRow = baseRowsArray[0];
      var data = {};
      if (this.getSystemType() === 'SROW') {
        data.rows = [];
        for (var i = 0; i < this.getNumRows(); i++) {
          data.rows.push({
            pixNumber: i + 1,
            outcomes: this.getOutcomesArray(baseRow)
          });
        }
      } else {
        data.outcomes = this.getOutcomesArray(baseRow);
      }
      options.data = data;
    }

    origSuccess = options.success;
    origError = options.error;

    return this.sync(
      'read',
      this,
      _.extend(options, {
        success: function(response) {
          self.set(_.extend({}, self.parse(response), { active: true }));
          origSuccess(self, response, options);
          self.trigger('sync', self, response, options);
        },

        error: function(xhr) {
          origError(self, xhr, options);
          self.trigger('error', self, xhr, options);
        }
      })
    );
  },
  parse: function(response) {
    var wager = new svs.maltipset.models.PixWager().get('wager');
    wager.bets[0].drawNum = this.get('drawNumber');
    if (response.pixes && response.pixes.length > 0) {
      var rows = response.pixes;
      for (var i = 0; i < rows.length; i++) {
        var rowOutcomes = response.pixes[i].outcomes;
        var rowOutcomesArray = rowOutcomes.map(function(outcome) {
          return outcome.value;
        });
        wager.bets[0].numberBoards[i] = {
          systemType: this.getSystemType(),
          systemNum: 0,
          participation: '0',
          rowPriceMulti: 1,
          boardData: rowOutcomesArray,
          boardProps: 'QUICKPICK'
        };
      }

      delete response.pixes;
    }
    if (
      response.pix &&
      response.pix.outcomes &&
      response.pix.outcomes.length > 0
    ) {
      var outcomes = response.pix.outcomes;
      var outcomesArray = outcomes.map(function(outcome) {
        return outcome.value;
      });
      wager.bets[0].numberBoards[0].boardData = outcomesArray;
      wager.bets[0].numberBoards[0].systemType = this.getSystemSize();
      wager.bets[0].numberBoards[0].systemNum = this.get('xpertSize');
      delete response.pix;
    }
    response.wager = wager;
    return response.wager.bets[0];
  },
  getOutcomesArray: function(baseRow) {
    var outcomesArray = [];
    baseRow.forEach(function(outcome, index) {
      outcomesArray[index] = {
        value: outcome
      };
    });
    return outcomesArray;
  },
  getSystemSize: function() {
    if (this.get('system') === svs.maltipset.constants.SYSTEM.NO_SYSTEM) {
      return svs.maltipset.constants.NUMBER_OF_MATCHES_TO_SELECT_NOSYSTEM;
    } else if (
      this.get('system') === svs.maltipset.constants.SYSTEM.R_SYSTEM
    ) {
      return svs.maltipset.collections.Board.prototype.getRSystemRows(this.get('xpertSize'));
    } else if (
      this.get('system') === svs.maltipset.constants.SYSTEM.M_SYSTEM
    ) {
      return svs.maltipset.collections.Board.prototype.calculateMSystem(this.get('xpertSize'));
    }
  },
  getSystemType: function() {
    switch (this.get('system')) {
      case svs.maltipset.constants.SYSTEM.NO_SYSTEM:
        return 'SROW';
      case svs.maltipset.constants.SYSTEM.M_SYSTEM:
        return 'MSYS';
      case svs.maltipset.constants.SYSTEM.R_SYSTEM:
        return 'RSYS';
      default:
    }
  },
  getNumRows: function() {
    if (this.get('system') === svs.maltipset.constants.SYSTEM.NO_SYSTEM) {
      return this.get('xpertSize');
    }
    return 1;
  }
});


 })(window);